module.exports = __webpack_public_path__ + "img/15beecoins.394ccc11.svg";